// Meta Pixel propio de Plick marketing — el MISMO pixel que plick.com.mx (372831828010062).
// Se carga solo cuando el tracking está habilitado (prod, ver PRJ-005) y NO rastrea pageviews
// del panel: existe únicamente para el evento de conversión `registro_plan_basico`, que antes
// disparaba la página intermedia www.plick.com.mx/activation-plick-basico tras el registro.

export const META_PIXEL_ID = '372831828010062';

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[];
  push?: Fbq;
  loaded?: boolean;
  version?: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

let initialized = false;

const ensureFbqStub = (): Fbq => {
  if (window.fbq) return window.fbq;
  const fbq = ((...args: unknown[]) => {
    // Antes de que cargue fbevents.js los llamados se encolan; después se ejecutan directo.
    if (fbq.callMethod) fbq.callMethod(...args);
    else fbq.queue.push(args);
  }) as Fbq;
  fbq.queue = [];
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  window.fbq = fbq;
  window._fbq = fbq;
  return fbq;
};

export const initMetaPixel = (pixelId: string): void => {
  if (initialized || typeof window === 'undefined' || !pixelId) return;
  initialized = true;
  ensureFbqStub();
  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);
  window.fbq?.('init', pixelId);
};

export const isMetaPixelInitialized = (): boolean => initialized;

const newEventId = (): string => {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch {
    // noop — entorno sin crypto.randomUUID
  }
  return `evt-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
};

// Evento de conversión con advanced matching: fbevents.js hashea solo em/ph en claro, así que
// se entregan trim+lowercase / solo dígitos. El eventID único por conversión deja listo el
// dedup contra una futura CAPI server-side que use el mismo ID.
export const metaPixelTrackRegistration = (
  pixelId: string,
  userData: { email?: string; phone?: string },
): string | null => {
  if (!initialized || typeof window === 'undefined' || !window.fbq) return null;
  const advanced: { em?: string; ph?: string } = {};
  if (userData.email) advanced.em = userData.email.trim().toLowerCase();
  if (userData.phone) advanced.ph = userData.phone.replace(/\D/g, '');
  try {
    if (advanced.em || advanced.ph) window.fbq('init', pixelId, advanced);
    const eventID = newEventId();
    window.fbq('trackCustom', 'registro_plan_basico', { eventID });
    return eventID;
  } catch {
    return null;
  }
};

// Conversión del flujo PAGA (registro legacy con token): paridad EXACTA con la página de
// aterrizaje que reemplazamos (plick.com.mx/activation-plick), que disparaba el evento
// estándar Purchase con value/currency fijos — sin eventID y sin advanced matching, porque
// la página original no los enviaba. NO cambiar por un evento custom ni agregar propiedades.
export const PAID_REGISTRATION_VALUE = 700.0;
export const PAID_REGISTRATION_CURRENCY = 'MXN';

export const metaPixelTrackPaidRegistration = (): boolean => {
  if (!initialized || typeof window === 'undefined' || !window.fbq) return false;
  try {
    window.fbq('track', 'Purchase', { value: PAID_REGISTRATION_VALUE, currency: PAID_REGISTRATION_CURRENCY });
    return true;
  } catch {
    return false;
  }
};
